// eslint-disable-next-line import/prefer-default-export
export enum EJWPlayerBucket {
  Recorded = 'recorded',
  Livestream = 'livestream',
}
